import { Link, makeStyles } from "@material-ui/core";
import * as React from "react";

const urlPattern = /(?:https?:\/\/|www\.)[^\s<>"']+/g;
const trailingPunctuationPattern = /[),.:;!?、。）」』】]+$/;

const useStyles = makeStyles(() => ({
  link: {
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  },
}));

type TextPart =
  | {
      type: "text";
      text: string;
    }
  | {
      type: "url";
      text: string;
      href: string;
    };

export const parseLinkifiedTextParts = (text: string): TextPart[] => {
  const parts: TextPart[] = [];
  let lastIndex = 0;

  text.replace(urlPattern, (matchedUrl, index) => {
    if (index > lastIndex) {
      parts.push({ type: "text", text: text.slice(lastIndex, index) });
    }

    const urlText = matchedUrl.replace(trailingPunctuationPattern, "");
    const trailingText = matchedUrl.slice(urlText.length);

    if (urlText) {
      parts.push({
        type: "url",
        text: urlText,
        href: urlText.startsWith("www.") ? `https://${urlText}` : urlText,
      });
    }
    if (trailingText) {
      parts.push({ type: "text", text: trailingText });
    }

    lastIndex = index + matchedUrl.length;
    return matchedUrl;
  });

  if (lastIndex < text.length) {
    parts.push({ type: "text", text: text.slice(lastIndex) });
  }

  return parts.length > 0 ? parts : [{ type: "text", text }];
};

interface LinkifiedTextProps {
  text?: string | null;
}

export const LinkifiedText: React.FC<LinkifiedTextProps> = ({ text }) => {
  const classes = useStyles();

  if (!text) return null;

  return (
    <>
      {parseLinkifiedTextParts(text).map((part, index) => {
        if (part.type === "url") {
          return (
            <Link
              key={`${part.href}-${index}`}
              href={part.href}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              {part.text}
            </Link>
          );
        }

        return <React.Fragment key={`${part.text}-${index}`}>{part.text}</React.Fragment>;
      })}
    </>
  );
};
